import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { RadioGroup, Text } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextRow,
  SelectControllerRow,
} from "@components";

import { NOA_FROM } from "../..";

export const TenderSecurity = ({
  securityMoney,
}: {
  securityMoney: number;
}) => {
  const { control, register, setValue, watch } = useFormContext();

  const { t } = useTranslation();

  return (
    <>
      <div className="row">
        <div className="col-lg-3">
          <Text weight="semibold" size="sm" color="title">
            {t("PROCUREMENT_CREATE.NOA.FORM.TENDER_SECURITY_SUBMISSION.LABEL")}
          </Text>
        </div>
        <div className="col-lg-7 d-flex flex-column gap-4">
          <Controller
            control={control}
            name={""}
            render={({ field }) => {
              return (
                <div className="d-flex gap-8 flex-wrap">
                  <RadioGroup
                    {...register(NOA_FROM.TENDER_SECURITY_SUBMISSION)}
                    name={NOA_FROM.TENDER_SECURITY_SUBMISSION}
                    id={NOA_FROM.TENDER_SECURITY_SUBMISSION}
                    options={[
                      {
                        id: "3",
                        label: `${t(
                          "PROCUREMENT_CREATE.NOA.FORM.TENDER_SECURITY_SUBMISSION.SUBMIT",
                        )}`,
                        value: "submitted",
                      },
                      {
                        id: "4",
                        label: `${t(
                          "PROCUREMENT_CREATE.NOA.FORM.TENDER_SECURITY_SUBMISSION.NOT_SUBMIT",
                        )}`,
                        value: "notSubmitted",
                      },
                    ]}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>

      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.NOA.FORM.SECURITY_MONEY_SUBMISSION_DATE"
        register={{ ...register(NOA_FROM.SECURITY_MONEY_SUBMISSION_DATE) }}
        name={NOA_FROM.SECURITY_MONEY_SUBMISSION_DATE}
      />

      <InputDateControllerRow
        control={control}
        label="PROCUREMENT_CREATE.NOA.FORM.SECURITY_MONEY_WITHDRAWAL_LAST_DATE"
        register={{ ...register(NOA_FROM.SECURITY_MONEY_WITHDRAWAL_LAST_DATE) }}
        name={NOA_FROM.SECURITY_MONEY_WITHDRAWAL_LAST_DATE}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.NOA.FORM.SECURITY_AMOUNT_PERCENTAGE"
        register={{ ...register(NOA_FROM.SECURITY_AMOUNT_PERCENTAGE) }}
        type="number"
        suffix={<div>%</div>}
        controlling
        onChange={(value) => {
          setValue(NOA_FROM.SECURITY_AMOUNT_PERCENTAGE, value);
          if (value) {
            setValue(
              NOA_FROM.PERFORMANCE_SECURITY_AMOUNT,
              securityMoney * (Number(value) / 100),
            );
          } else {
            setValue(NOA_FROM.PERFORMANCE_SECURITY_AMOUNT, securityMoney);
          }
        }}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.NOA.FORM.PERFORMANCE_SECURITY_AMOUNT"
        register={{ ...register(NOA_FROM.PERFORMANCE_SECURITY_AMOUNT) }}
        disabled
      />

      <SelectControllerRow
        label="PROCUREMENT_CREATE.NOA.FORM.SECURITY_MONEY_SUBMISSION_TYPE"
        control={control}
        name={NOA_FROM.SECURITY_MONEY_SUBMISSION_TYPE}
        register={{ ...register(NOA_FROM.SECURITY_MONEY_SUBMISSION_TYPE) }}
        options={[
          { label: "Pay order", value: "pay order" },
          { label: "Cash Money", value: "cash money" },
        ]}
        setValue={setValue}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.NOA.FORM.SECURITY_MONEY_SUBMITTED_TO"
        register={{ ...register(NOA_FROM.SECURITY_MONEY_SUBMITTED_TO) }}
      />
    </>
  );
};
